// assets
import {
  AppstoreOutlined,
  DollarCircleOutlined,
  FundOutlined,
  ProfileOutlined,
  FolderOpenOutlined,
  TransactionOutlined,
  WalletOutlined
} from '@ant-design/icons';
import { Rights } from 'graphql/types';

// type
import { NavItemType } from 'types/menu';

// icons
const icons = {
  DollarCircleOutlined,
  AppstoreOutlined,
  FundOutlined,
  ProfileOutlined,
  FolderOpenOutlined,
  TransactionOutlined,
  WalletOutlined
};

// ==============================|| MENU ITEMS - DASHBOARD ||============================== //

const dashboard: NavItemType = {
  id: 'group-dashboard',
  type: 'group',
  oneOfRights: [Rights.IsSuperAdmin, Rights.IsInvestor, Rights.IsFunder],
  children: [
    {
      id: 'admin-dashboard',
      title: 'Admin Dashboard',
      type: 'item',
      url: '/dashboard/admin',
      icon: { anticon: icons.AppstoreOutlined },
      rights: [Rights.IsSuperAdmin]
    },
    {
      id: 'investor-dashboard',
      title: 'Investor Dashboard',
      type: 'item',
      url: '/dashboard/investor',
      icon: { anticon: icons.FundOutlined },
      rights: [Rights.IsInvestor]
    },
    {
      id: 'funder-dashboard',
      title: 'Funder Dashboard',
      type: 'item',
      url: '/dashboard/funder',
      icon: { anticon: icons.FundOutlined },
      rights: [Rights.IsFunder]
    },
    {
      id: 'my-ledger',
      title: 'Ledger',
      type: 'item',
      url: '/my-ledger',
      icon: { anticon: icons.WalletOutlined },
      oneOfRights: [Rights.IsInvestor, Rights.IsFunder]
    },
    {
      id: 'my-portfolio-investor',
      title: 'My Portfolio',
      type: 'item',
      url: '/my-portfolio',
      icon: { anticon: icons.FolderOpenOutlined },
      oneOfRights: [Rights.IsInvestor, Rights.IsFunder]
    }
  ]
};

export default dashboard;
